import { isTestEnvironment } from "../apiCaching/POST-Requests/helperModules/helperFunctions";

export function logInTestEnv(...message: any[]): void {
    if (isTestEnvironment()) {
        console.log(message.join(" "));
    }
  }